const debounce = (callback, wait) => {
	let func;
	let timeoutId = null;
	let frameID;
	if (wait) {
		func = (...args) => {
			window.clearTimeout(timeoutId);
			timeoutId = window.setTimeout(() => {
				callback(...args);
			}, wait);
		};
		func.abort = () => {
			window.clearTimeout(timeoutId);
		}
	} else {
		func = (...args) => {
			if (frameID)cancelAnimationFrame(frameID);
			frameID = requestAnimationFrame(() => {
				callback(...args);
			});
		};
		func.abort = () => {
			cancelAnimationFrame(frameID);
		}
	}
	return func;
}

export default debounce;